import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { TResponse } from "../../../types/common";
import { IQuoteTemplate, IQuoteTemplateCreatePayload } from "../../../types/api/quoteTemplate";

export const listQuoteTemplates = (): Promise<AxiosResponse<TResponse<IQuoteTemplate[]>>> =>
  axios.get(API_ENDPOINTS.QUOTE_TEMPLATE_LIST);

export const createQuoteTemplate = (
  data: IQuoteTemplateCreatePayload,
): Promise<AxiosResponse<TResponse<IQuoteTemplate>>> =>
  axios.post(API_ENDPOINTS.QUOTE_TEMPLATE_CREATE, data);

export const deleteQuoteTemplate = (id: number): Promise<AxiosResponse<TResponse<null>>> =>
  axios.delete(API_ENDPOINTS.QUOTE_TEMPLATE_DELETE(id));
